export type WebsitesModalView =
  | 'loading'
  | 'error'
  | 'update'
  | 'create'
  | 'no-website';

/**
 * Decide what the IDX Websites modal should render.
 *
 * A failed tenant read must surface as `error` (retry) rather than falling
 * through to create/update: the storefront service returns a non-success
 * response when the authoritative read is unavailable, so `isError` here means
 * "we don't know whether a site exists", not "no site". Rendering create/update
 * against that would either offer Create over a real site or expose the update
 * form against synthetic defaults.
 */
export function resolveWebsitesModalView(state: {
  isLoading: boolean;
  isError: boolean;
  configured: boolean | undefined;
  showCreateForm: boolean;
}): WebsitesModalView {
  if (state.isLoading) return 'loading';
  if (state.isError) return 'error';
  if (state.configured) return 'update';
  if (state.showCreateForm) return 'create';
  return 'no-website';
}
